import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { ToastrService } from 'ngx-toastr';

import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { ProjectService } from '../../../../services/project.service';
import { CommonModule } from '@angular/common';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DirectionService } from '../../../../services/direction.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-resource',
  standalone: true,
  imports: [
    InputTextareaModule, TableModule,
    CommonModule, ConfirmPopupModule,
    ButtonModule, FormsModule,
    InputTextModule, TooltipModule,
    TranslateModule
  ],
  templateUrl: './resource.component.html',
  styleUrl: './resource.component.scss',
  providers: [MessageService, ConfirmationService],
})
export class ResourceComponent implements OnInit {
  @ViewChild('budget_itemForm') budget_itemForm!: FormGroup;
  @ViewChild('resourceForm') resourceForm!: FormGroup;
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  @Output() submitResourceSuccess = new EventEmitter<boolean>();

  @Input()
  strategyId!: number;
  @Input()

  projectId!: number;

  dir!: 'rtl' | 'ltr';
  constructor(private toastr: ToastrService,
    private confirmationService: ConfirmationService,
    private projectService: ProjectService,
    private directionService: DirectionService
  ) {
  }
  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })

  }
  _Resource: any = this.createEmptyResource();
  @Input() set Resource(value: any) {
    console.log("Resource Resource", value);
    if (!value) {
      this._Resource = this.createEmptyResource();
      return;
    }
    // Set is_within_budget_limit to true by default if not set
    if (value.is_within_budget_limit === undefined) {
      value.is_within_budget_limit = true;
    }
    if (!Array.isArray(value.budget_items)) {
      value.budget_items = [];
    }
    value.budget_items = this.normalizeBudgetItems(value.budget_items);
    this._Resource = value;
  }
  get Resource() {
    return this._Resource ?? this.createEmptyResource();
  }

  private normalizeBudgetItems(items: any[]) {
    return (items ?? []).map((item) => {
      const name = (item?.name ?? '').toString().trim() || '.';
      const value = item?.value ?? item?.amount ?? 0;
      const description = (item?.description ?? '').toString().trim() || name;

      return {
        ...item,
        name,
        value: +value,
        description,
      };
    });
  }

  private createEmptyResource() {
    return {
      id: 0,
      project_id: this.projectId ?? 0,
      estimated_budget: null,
      sponsor_engagement: null,
      required_internal_resources: '',
      required_external_resources: '',
      rationalization_method: '',
      budget_items: [],
      is_within_budget_limit: true,
    };
  }
  isVisiblBudgetItemModal = false;
  isResourcSubmitted = false;
  selected_budget_item = {} as any;
  selected_budget_item_index = -1;

  isBudgetItemFormSubmitted = false;
  confirmBudgetItemsDelete(event: Event, index: number) {
    const target = event.target as HTMLElement;
    this.confirmationService.confirm({
      target: target,
      message: this.dir == 'rtl' ? 'هل تريد تأكيد المسح؟' : 'Do you want to confirm the deletion?',
      accept: () => {
        this.Resource.budget_items.splice(index, 1)
        this.toastr.success(this.dir == 'rtl' ? 'تم المسح ' : 'The budget item has been deleted successfully.', this.dir == 'rtl' ? 'عملية ناجحة' : 'Success');
      },
      reject: () => {
        this.toastr.info(this.dir == 'rtl' ? "تم الالغاء" : "The deletion has been canceled.", this.dir == 'rtl' ? 'الغاء' : 'Canceled');
      }
    });
  }

  accept() {
    this.confirmPopup.accept();
  }
  reject() {
    this.confirmPopup.reject();
  }
  openUpdatBudgetItemeModal(index: number) {
    console.log(this.Resource.budget_items);
    this.isVisiblBudgetItemModal = true;
    this.selected_budget_item_index = index;
    const budget_items = structuredClone(this.Resource.budget_items);
    this.selected_budget_item = budget_items[index];
  }
  closeBudgetItemModal() {
    this.isVisiblBudgetItemModal = false;
    this.selected_budget_item = {} as any
  }
  submitBudget_itemForm() {
    this.isBudgetItemFormSubmitted = true;

    if (this.selected_budget_item_index != -1 && this.budget_itemForm.valid) {
      this.Resource.budget_items[this.selected_budget_item_index] = this.budget_itemForm.value
      this.budget_itemForm.reset({});
      this.toastr.success(this.dir == 'rtl' ? 'تمت الاضافة بنجاح' : 'The item has been added successfully.', this.dir == 'rtl' ? 'نجاح' : 'Success')
      this.isBudgetItemFormSubmitted = false;
    }
    else if (this.budget_itemForm.valid) {
      this.Resource.budget_items.push(this.budget_itemForm.value)
      this.budget_itemForm.reset({});
      this.toastr.success(this.dir == 'rtl' ? 'تم الاضافة بنجاح' : 'The item has been added successfully.', this.dir == 'rtl' ? 'نجاح' : 'Success')
      this.isBudgetItemFormSubmitted = false;
    } else {
      this.toastr.error(this.dir == 'rtl' ? 'يرجي مراجعة البيانات' : 'Please check the data', 'فشل');
    }
  }


  submitResource() {
    this.isResourcSubmitted = true;

    if (this.resourceForm.valid) {
      // Ensure is_within_budget_limit is set to true
      this.Resource.is_within_budget_limit = true;
      const payload = {
        ...this.Resource,
        budget_items: this.normalizeBudgetItems(this.Resource.budget_items),
      };
      
      this.projectService.updateResource(this.strategyId, this.projectId, payload.id, payload).subscribe((response: any) => {
        console.log(response);
        this.toastr.success(this.dir == 'rtl' ? 'تم التحديث بنجاح' : 'The resource has been updated successfully.', this.dir == 'rtl' ? 'نجاح' : 'Success')
        this.isResourcSubmitted = false;
        this.submitResourceSuccess.emit(true)
      })
    }
  }
}
